//部门管理相关请求
import { request } from "@/utils"

export function getDepartmentListAPI(id) {
  return request({
    url: `/crostars-company-department/list-by-company-id?id=${id}`,
    method: 'POST',
  })
}

export function getDepartmentAPI(id) {
  return request({
    url: `/crostars-company-department/get-department-by-id?id=${id}`,
    method: 'POST',
  })
}